import { DataGridHeader, DataGridBody } from './components'
import { DataGridProps } from './types'
import '@/assets/scss/control/data-grid.scss'

function DataGrid<TData> ( props: DataGridProps ) {
    const { defaultColDef, columnDefs, rowData, noRowNo, setRowData } = props

    return (
        <>
            <DataGridHeader
                columnDefs={ columnDefs }
                noRowNo={ noRowNo }
            />
            <DataGridBody<TData>
                rowData={ rowData }
                defaultColDef={ defaultColDef }
                columnDefs={ columnDefs }
                noRowNo={ noRowNo }
                setRowData={ setRowData }
            />
        </>
    )
}

export default DataGrid